export default {
    mounted() {
        // Set validation observer
        this.$store.set('func_data/validation_observer',this.$refs[this.stepName])
    },
    destroyed() {
        this.$store.set('func_data/validation_observer',null)
    }
}
